module.exports = __webpack_public_path__ + "static/img/webchat.297ff4e4.png";